/**
 * trạng thái submit đồng bộ danh mục
 * dvhung2 8.4.2024
 */
export default{
    Insert: 1,
    Update: 2,
    Yes: 3,
    No: 4,
};